<div
    class="e-invoicing-banner flex items-center cursor-pointer"
    (click)="onBannerClick()"
>
    <div class="banner-content pointer-event-none">
        <div>
            <div class="banner-content-text leading-tight pointer-event-none"
                [innerHTML]="'faq.eInvoicing.bannerMessage' | translate"
            >
            </div>
            <span class="flex items-center banner-content-text text-primary font-semibold pointer-event-none">
                {{ 'faq.eInvoicing.viewFAQ' | translate }}
                <mat-icon class="w-[14px] text-primary" svgIcon="arrow-right-short"></mat-icon>
            </span>
        </div>
    </div>
    <div class="banner-icon">
        <img
            src="assets/images/faq/e-invoicing-banner-icon.svg"
            alt="E-Invoicing Icon" />
    </div>
</div>
